import {
  PassportsList as Data,
  PassportsListCollection as Collection,
} from '@/typings/api/PassportList'
import { BaseApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'
import { PassportHistory } from '@/typings/api/Passport'
import { BaseApiParams } from '@/typings/common'

export class PassportApi extends BaseApiAuth<Data, Collection> {
    protected readonly endpoint = 'ate/passport';

    public downloadUrl<P extends BaseApiParams>(
      data: Record<string, unknown>, rawParams?: P, config?: AxiosRequestConfig,
    ) {
      const path = 'download/list/'
      const [url, params] = this.getUrl(path, rawParams)
      return this.request('POST', url, { data, params, ...config })
    }

    public downloadPassportById(id: Data['id']) {
      const path = `download/${id}/`
      const [url] = this.getUrl(path)
      return this.request('POST', url)
    }

    public downloadPrefill() {
      const path = 'download/prefill/'
      const [url] = this.getUrl(path)
      return url
    }

    public uploadPrefill(file: File, config?: AxiosRequestConfig) {
      const path = 'upload/prefill/'
      const [url] = this.getUrl(path)
      const data = new FormData()
      data.append('file', file)
      return this.request('POST', url, { data, ...config })
    }

    public passportActivate(id: Data['id']) {
      const path = `${id}/activate/`
      const [url] = this.getUrl(path)
      return this.request('POST', url)
    }

    public history<P extends BaseApiParams>(id: Data['id'], data: Record<string, unknown>, rawParams?: P, config?: AxiosRequestConfig) {
      const path = `${id}/history/`
      const [url, params] = this.getUrl(path, rawParams)
      return this.request<never, { data: PassportHistory[] }>('POST', url, { data, params, ...config })
    }

    public downloadTemplateActivateDeactivateURL() {
      const path = 'download/template_activate_deactivate/'
      const [url] = this.getUrl(path)
      return url
    }

    public uploadTemplateActivateDeactivate(file: File, config?: AxiosRequestConfig) {
      const path = 'upload/template_activate_deactivate/'
      const [url] = this.getUrl(path)
      const data = new FormData()
      data.append('file', file)
      return this.request('POST', url, { data, ...config })
    }
}
